export const API_ORGANIZATION_SINGLE = '/organization/:organizationId'

export const makeOrganizationRequestRoute = organizationId => {
  return API_ORGANIZATION_SINGLE.replace(':organizationId', organizationId)
}
